(function () {
	'use strict';

	// ─── Disclosures (Arelis FAQ, practice areas accordion on phones) ───────────
	// <details> opens instantly by default; animate the answer's height over
	// 200 ms ease-out (motion spec 04). Without JS or with reduced motion the
	// native behaviour stays.

	var SUMMARY = '.arelis-faq__question, .arelis-practice-accordion__title';
	var BODY = '.arelis-faq__answer, .arelis-practice-accordion__body';

	var DURATION = 200;
	var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	function animate(details, opening) {
		var answer = details.querySelector(BODY);
		if (!answer || reducedMotion.matches || typeof answer.animate !== 'function') {
			details.open = opening;
			return;
		}

		if (opening) {
			details.open = true;
		}
		var full = answer.scrollHeight;
		var from = opening ? 0 : full;
		var to = opening ? full : 0;

		var animation = answer.animate(
			[{ height: from + 'px', opacity: opening ? 0 : 1 }, { height: to + 'px', opacity: opening ? 1 : 0 }],
			{ duration: DURATION, easing: 'ease-out' }
		);
		details.dataset.animating = '1';
		animation.onfinish = function () {
			delete details.dataset.animating;
			if (!opening) {
				details.open = false;
			}
		};
	}

	document.addEventListener('click', function (event) {
		var summary = event.target.closest(SUMMARY);
		if (!summary) {
			return;
		}
		var details = summary.parentElement;
		event.preventDefault();
		if (details.dataset.animating) {
			return;
		}
		animate(details, !details.open);
	});

})();
